var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Down_Arrow_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Down_Arrow_2",
    "data-name": "Down Arrow \\u20132",
    clipPath: "url(#clip-Down_Arrow_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37700",
    "data-name": "Path 37700",
    d: "M10.445,10.529V4h1.63v6.529h2.445l-3.26,3.252L8,10.529Z",
    transform: "translate(-5 -2.89)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnDownArrow);
export default __webpack_public_path__ + "static/media/ColumnDownArrow.ff4b34ba0fe0216135015436a868e244.svg";
export { ForwardRef as ReactComponent };